import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import LangContext, { i18n } from 'modules/shared/context/langContext';
import { PageHeader, Button, Descriptions, Row, Col, Tooltip, Table, Popconfirm, Icon } from 'antd';
import { withRouter } from 'react-router-dom';
import GoogleMapReact from 'google-map-react';
//import HPlatform, { HMap, HMapMarker } from "react-here-map";
import AuthorizeComponent from './../../../auth/components/AuthorizeComponent';
import IconMarker from '../../../shared/components/map-assets/Marker/IconMarker';
import { autoGenKey, helper_convertDateformat } from '../../../../lib/helper';
import { GeneralStyledContent } from '../../../../styled/common-styled';
import { loadDashcamera, removeLists, loadEmergencyCase } from '../../actions';
import '../../../../styled/old-web/alert-icon.css';
import { LatLngFormat } from '../../../../lib/helper';
const ButtonGroup = Button.Group;
const defaultSiteImg =
	'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAeCAYAAAAo5+5WAAAACXBIWXMAAAsTAAALEwEAmpwYAAAKT2lDQ1BQaG90b3Nob3AgSUNDIHByb2ZpbGUAAHjanVNnVFPpFj333vRCS4iAlEtvUhUIIFJCi4AUkSYqIQkQSoghodkVUcERRUUEG8igiAOOjoCMFVEsDIoK2AfkIaKOg6OIisr74Xuja9a89+bN/rXXPues852zzwfACAyWSDNRNYAMqUIeEeCDx8TG4eQuQIEKJHAAEAizZCFz/SMBAPh+PDwrIsAHvgABeNMLCADATZvAMByH/w/qQplcAYCEAcB0kThLCIAUAEB6jkKmAEBGAYCdmCZTAKAEAGDLY2LjAFAtAGAnf+bTAICd+Jl7AQBblCEVAaCRACATZYhEAGg7AKzPVopFAFgwABRmS8Q5ANgtADBJV2ZIALC3AMDOEAuyAAgMADBRiIUpAAR7AGDIIyN4AISZABRG8lc88SuuEOcqAAB4mbI8uSQ5RYFbCC1xB1dXLh4ozkkXKxQ2YQJhmkAuwnmZGTKBNA/g88wAAKCRFRHgg/P9eM4Ors7ONo62Dl8t6r8G/yJiYuP+5c+rcEAAAOF0ftH+LC+zGoA7BoBt/qIl7gRoXgugdfeLZrIPQLUAoOnaV/Nw+H48PEWhkLnZ2eXk5NhKxEJbYcpXff5nwl/AV/1s+X48/Pf14L7iJIEyXYFHBPjgwsz0TKUcz5IJhGLc5o9H/LcL//wd0yLESWK5WCoU41EScY5EmozzMqUiiUKSKcUl0v9k4t8s+wM+3zUAsGo+AXuRLahdYwP2SycQWHTA4vcAAPK7b8HUKAgDgGiD4c93/+8//UegJQCAZkmScQAAXkQkLlTKsz/HCAAARKCBKrBBG/TBGCzABhzBBdzBC/xgNoRCJMTCQhBCCmSAHHJgKayCQiiGzbAdKmAv1EAdNMBRaIaTcA4uwlW4Dj1wD/phCJ7BKLyBCQRByAgTYSHaiAFiilgjjggXmYX4IcFIBBKLJCDJiBRRIkuRNUgxUopUIFVIHfI9cgI5h1xGupE7yAAygvyGvEcxlIGyUT3UDLVDuag3GoRGogvQZHQxmo8WoJvQcrQaPYw2oefQq2gP2o8+Q8cwwOgYBzPEbDAuxsNCsTgsCZNjy7EirAyrxhqwVqwDu4n1Y8+xdwQSgUXACTYEd0IgYR5BSFhMWE7YSKggHCQ0EdoJNwkDhFHCJyKTqEu0JroR+cQYYjIxh1hILCPWEo8TLxB7iEPENyQSiUMyJ7mQAkmxpFTSEtJG0m5SI+ksqZs0SBojk8naZGuyBzmULCAryIXkneTD5DPkG+Qh8lsKnWJAcaT4U+IoUspqShnlEOU05QZlmDJBVaOaUt2ooVQRNY9aQq2htlKvUYeoEzR1mjnNgxZJS6WtopXTGmgXaPdpr+h0uhHdlR5Ol9BX0svpR+iX6AP0dwwNhhWDx4hnKBmbGAcYZxl3GK+YTKYZ04sZx1QwNzHrmOeZD5lvVVgqtip8FZHKCpVKlSaVGyovVKmqpqreqgtV81XLVI+pXlN9rkZVM1PjqQnUlqtVqp1Q61MbU2epO6iHqmeob1Q/pH5Z/YkGWcNMw09DpFGgsV/jvMYgC2MZs3gsIWsNq4Z1gTXEJrHN2Xx2KruY/R27iz2qqaE5QzNKM1ezUvOUZj8H45hx+Jx0TgnnKKeX836K3hTvKeIpG6Y0TLkxZVxrqpaXllirSKtRq0frvTau7aedpr1Fu1n7gQ5Bx0onXCdHZ4/OBZ3nU9lT3acKpxZNPTr1ri6qa6UbobtEd79up+6Ynr5egJ5Mb6feeb3n+hx9L/1U/W36p/VHDFgGswwkBtsMzhg8xTVxbzwdL8fb8VFDXcNAQ6VhlWGX4YSRudE8o9VGjUYPjGnGXOMk423GbcajJgYmISZLTepN7ppSTbmmKaY7TDtMx83MzaLN1pk1mz0x1zLnm+eb15vft2BaeFostqi2uGVJsuRaplnutrxuhVo5WaVYVVpds0atna0l1rutu6cRp7lOk06rntZnw7Dxtsm2qbcZsOXYBtuutm22fWFnYhdnt8Wuw+6TvZN9un2N/T0HDYfZDqsdWh1+c7RyFDpWOt6azpzuP33F9JbpL2dYzxDP2DPjthPLKcRpnVOb00dnF2e5c4PziIuJS4LLLpc+Lpsbxt3IveRKdPVxXeF60vWdm7Obwu2o26/uNu5p7ofcn8w0nymeWTNz0MPIQ+BR5dE/C5+VMGvfrH5PQ0+BZ7XnIy9jL5FXrdewt6V3qvdh7xc+9j5yn+M+4zw33jLeWV/MN8C3yLfLT8Nvnl+F30N/I/9k/3r/0QCngCUBZwOJgUGBWwL7+Hp8Ib+OPzrbZfay2e1BjKC5QRVBj4KtguXBrSFoyOyQrSH355jOkc5pDoVQfujW0Adh5mGLw34MJ4WHhVeGP45wiFga0TGXNXfR3ENz30T6RJZE3ptnMU85ry1KNSo+qi5qPNo3ujS6P8YuZlnM1VidWElsSxw5LiquNm5svt/87fOH4p3iC+N7F5gvyF1weaHOwvSFpxapLhIsOpZATIhOOJTwQRAqqBaMJfITdyWOCnnCHcJnIi/RNtGI2ENcKh5O8kgqTXqS7JG8NXkkxTOlLOW5hCepkLxMDUzdmzqeFpp2IG0yPTq9MYOSkZBxQqohTZO2Z+pn5mZ2y6xlhbL+xW6Lty8elQfJa7OQrAVZLQq2QqboVFoo1yoHsmdlV2a/zYnKOZarnivN7cyzytuQN5zvn//tEsIS4ZK2pYZLVy0dWOa9rGo5sjxxedsK4xUFK4ZWBqw8uIq2Km3VT6vtV5eufr0mek1rgV7ByoLBtQFr6wtVCuWFfevc1+1dT1gvWd+1YfqGnRs+FYmKrhTbF5cVf9go3HjlG4dvyr+Z3JS0qavEuWTPZtJm6ebeLZ5bDpaql+aXDm4N2dq0Dd9WtO319kXbL5fNKNu7g7ZDuaO/PLi8ZafJzs07P1SkVPRU+lQ27tLdtWHX+G7R7ht7vPY07NXbW7z3/T7JvttVAVVN1WbVZftJ+7P3P66Jqun4lvttXa1ObXHtxwPSA/0HIw6217nU1R3SPVRSj9Yr60cOxx++/p3vdy0NNg1VjZzG4iNwRHnk6fcJ3/ceDTradox7rOEH0x92HWcdL2pCmvKaRptTmvtbYlu6T8w+0dbq3nr8R9sfD5w0PFl5SvNUyWna6YLTk2fyz4ydlZ19fi753GDborZ752PO32oPb++6EHTh0kX/i+c7vDvOXPK4dPKy2+UTV7hXmq86X23qdOo8/pPTT8e7nLuarrlca7nuer21e2b36RueN87d9L158Rb/1tWeOT3dvfN6b/fF9/XfFt1+cif9zsu72Xcn7q28T7xf9EDtQdlD3YfVP1v+3Njv3H9qwHeg89HcR/cGhYPP/pH1jw9DBY+Zj8uGDYbrnjg+OTniP3L96fynQ89kzyaeF/6i/suuFxYvfvjV69fO0ZjRoZfyl5O/bXyl/erA6xmv28bCxh6+yXgzMV70VvvtwXfcdx3vo98PT+R8IH8o/2j5sfVT0Kf7kxmTk/8EA5jz/GMzLdsAAAAgY0hSTQAAeiUAAICDAAD5/wAAgOkAAHUwAADqYAAAOpgAABdvkl/FRgAABOVJREFUeNqklWtsFGUUhp9vZnY625ZeaLc3LoUCtpaLQhEKxAZJxRQETMQolkskSpRIQ1AblJiooFz+GIwGQ6I/QFFDhEAQo6aCRiOltCrYcrEt0FJatqWlu937zHz+QJBCdwF5k/k1530yc8753k9IKYkiJ7C0rqehrLGvtcAd6s6xpU2KnuTJNtLPTUwpqEuPS90BHBvILKKA39hxbn/FjvP7M2t7GvCZQSJ2BACHoqEKleHxWczLeYRVoxcdyE3IqQROxgIPr/c07VlZu77o50vVJOiDyHa60ISG+LdAcrW+N+Kl3deOy5nBhvEVrMhbuBTYORB4aNWl6hPzf305JWiFyR80AokkRqvQFI3OUDfuvgusHb+KjeNXPw980g/c4GlqfvC7hSOT9EQ0odIT9uBQNGwpidcM0vRkQOA3A1wO9yKEwJIWmlDJNNJovnKarQ+tp2JM+UTgDyGlJGxHtk6rKq9o8DSRpqcwKnE4y0bMJz0uFdO28Jo+LgY6AUmyI5Esw4WmKASsEIfcR9l38RCaULkYcFNd+kXL5NSxuUgp73u3Ybvk8zyZe2C2zP/2cdkb6ZM36veeUzL/4Dw5+psy+U79x/JmLateJwftmSL13RPljKolUkq5VgnbkeW7W78nLSEHb8THyIQhJGkJ/Xp5xnue054mGj3NnPKcvaXXRYML8UZ85CUO5cjl4/zUeewZpbanoaTJ10qanoIiFIJWGFva/YckVJxaPLoWj6Hqt4D9ZhBVqCgoWNLksLsmUzvjPZfnNwOoQok6/YhtEoh4QVr4reAt76+toERiqHGc9bUlat1hT4plW9f3dCDpioNEPRlLWiRq8cSSQzgIWEGhGYoeEkKJkzGKy7JncLrsACCJV42YYBsbVShouQk5LYaqj7v2OwPJUOPIcbq4nQQQsIJkGy6/Min1/j8zjDQCVoh7l8CWNg+kFvQoWUb6vimDx9EWcCOE+J+4q74+088QZyaPZhafUIC9i3Pn9ZlWEMu2MNQ4lBgbMmC+qnEAtPguMCe7hGzD9aECmPNzZr5dklFMt7+DFn87Edu8K/BfvY1YdhhdNXg1f9kJ4PD1EDrWXX92+o+LR0Rsk/LcuVSMWUyCamBHGapAYEqLw+4a3ju5nU5fG5snraOyYHkRUHdjbA7b1XKwpfy3VxjkSMKpGuiqAztKbF5LN78ZxBPsojzvST6bumklsG2goF+0sm7Drm1ndpKfnH/11ogyTylBVzTO+9sZ6szk+GN79jvVuAWxrqZt06rKX6zprmds8qio/VaFQlfoCj1hD7Wzv2odmzQ6F/7r20Djf2nvjK1HU/UkWv0daEIdsL9BK0yHv52dxRsZmzR65o3QaGCyjPRZX09/3+uJ9OGzAtf39MavbfQ0UVm4gqeGzn4CaL6ZEW1hfSWuotI1+cto9jT3Sz5VKDT2tTDVVcTmCWs2APvu5voHIGxHthT98PRrFwIdDHFmYEuJaZs0+lqpKf2yuii1sDiaN+YR0xXHm5snrPZeCfViS4kiFP72tfJC3kKKUgtfj+W93dkNzckueas0azptATchK0ySlkBl/nNHgUP3Agb46Nnhc0OesIe2gJu52Q8zKnHYptuZ7gQcmpUx5ReQBLrqKHFNBjhwW5eU8k6eBVtOfdq25MjaLnfw8gd34vlnAGgEdXydUoApAAAAAElFTkSuQmCC';

const defaultPlantImg =
	'data:image/png;base64,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';

const col = [
	{
		title: <LangContext.Consumer>{(i18n) => i18n.v.vehicle}</LangContext.Consumer>,
		dataIndex: 'vehicle_code',
	},
	{
		title: <LangContext.Consumer>{(i18n) => 'เริ่มเทปูน'}</LangContext.Consumer>,
		dataIndex: 'unload_start_at',
	},
	{
		title: <LangContext.Consumer>{(i18n) => i18n.d.duration}</LangContext.Consumer>,
		dataIndex: 'duration',
	},
	{
		title: <LangContext.Consumer>{(i18n) => i18n.q.quantity}</LangContext.Consumer>,
		dataIndex: 'quantity',
	},
];

export class ActivityOutSideArea extends Component {
	state = {
		map: null,
		maps: null,
		mapAPI: null,
		mapOptions: {
			center: {
				lat: 13.7527296,
				lng: 100.5387776,
			},
			zoom: 14,
		},
		isPlantEdit: false,
		isSiteEdit: false,
		siteGeoFene: [],
		sitePolygon: [],
		plantGeoFene: [],
		plantPolygon: [],
		isMenuMapToolsCLick: '',
		haveDrawPointOnMap: false,
		dataActive: [],
		dataWaiting: [],
		dataLogoff: [],
		currentPage: 1,
		page: 1,
		size: 4,
		//job info

		plantId: '',
		plantLat: '',
		plantLng: '',
		siteId: '',
		siteLat: '',
		siteLng: '',
		tableDetailData: [],
		ticketNo: '',
		vehicleCode: '',
		plantName: '',
		siteName: '',
		cementLoadStartDateTime: '',
		cementUnloadStartDateTime: '',
		plantMoveOutDateTime: '',
		siteArrivalDateTime: '',
		siteDepartureDateTime: '',
		plantDepartureDateTime: '',
		unloadQuntityPerAmount: '',
		address: '',
		description: '',
		flow: '',
	};

	loadData = () => {
		let self = this;
		let sdrId = self.props.match.params.id;
		fetch(`${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/getactivityoutsidearea`, {
			method: 'POST',
			mode: 'cors',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${self.props.auth.accessToken}`,
			},
			body: JSON.stringify({
				sdr_id: sdrId,
				company_id: self.props.profile.company_id,
				zone: 'All',
				plant: 'All',
				status: 'active',
				vehicle_type: 'All',
				plant_name: 'All',
				location_group_id: 'All',
				speed_id: '',
				group: '',
				sales_order: '',
				tracking_site_id: '',
				status_dialog: '',
				tracking_plant_id: '',
			}),
		})
			.then((response) => response.json())
			.then((res) => {
				console.log('res : ', res);
				self.setState(
					{
						ticketNo: res.deliver_result.trip_code,
						vehicleCode: res.deliver_result.code,
						siteName: `${res.deliver_result.site_name} (${res.deliver_result.site_code})`,
						cementLoadStartDateTime: res.deliver_result.load_start_at,
						plantMoveOutDateTime: res.deliver_result.plant_move_out_at,
						plantDepartureDateTime: res.deliver_result.plant_move_out_at,
						siteArrivalDateTime: res.deliver_result.cust_move_in_at,
						siteDepartureDateTime: res.deliver_result.cust_move_out_at,
						cementUnloadStartDateTime: res.deliver_result.cust_unload_start_at,
						unloadQuntityPerAmount: `${res.unload_quantity} / ${res.deliver_result.load_amount}`,
						address: res.deliver_result.address,
						description: res.deliver_result.description,
						tableDetailData: res.unload_details,
						siteId: res.site_id,
						siteLat: res.site_lat,
						siteLng: res.site_lng,
						plantId: res.plant_id,
						plantLat: res.plant_lat,
						plantLng: res.plant_lng,
						flow: res.deliver_result.flow,
					},
					() => {
						this.createMarker();
						this.setBound();
					}
				);
			})
			.catch(function() {});
	};

	createMarker = () => {};

	setBound = () => {
		if (this.state.maps != null) {
			let bounds = new this.state.maps.LatLngBounds();
			let position = null;

			for (let i = 0; i < this.state.tableDetailData.length; i++) {
				if (
					LatLngFormat(this.state.tableDetailData[i].lat, 'lat') &&
					LatLngFormat(this.state.tableDetailData[i].lng, 'lng')
				) {
					position = new this.state.maps.LatLng(
						this.state.tableDetailData[i].lat,
						this.state.tableDetailData[i].lng
					);
					bounds.extend(position);
				}
			}

			if (LatLngFormat(this.state.siteLat, 'lat') && LatLngFormat(this.state.siteLng, 'lng')) {
				position = new this.state.maps.LatLng(this.state.siteLat, this.state.siteLng);
				bounds.extend(position);
			}

			if (LatLngFormat(this.state.plantLat, 'lat') && LatLngFormat(this.state.plantLng, 'lng')) {
				position = new this.state.maps.LatLng(this.state.plantLat, this.state.plantLng);
				bounds.extend(position);
			}

			this.state.map.fitBounds(bounds);
		}
	};

	handleClearUp = () => {
		if (this.state.isPlantEdit) {
			this.clearAreaMarker(this.state.isPlantEdit, 'plant');
		}
		if (this.state.isSiteEdit) {
			this.clearAreaMarker(this.state.isSiteEdit, 'site');
		}
	};

	clearAreaMarker = (isEdit, location) => {
		this.state.maps.event.clearListeners(this.state.map, 'click');
		if (isEdit && location === 'site') {
			if (this.state.siteGeoFene != []) {
				this.state.sitePolygon.map((value, index) => {
					value.setMap(null);
				});
			}
			this.setState({
				siteGeoFene: [],
				sitePolygon: [],
				haveDrawPointOnMap: false,
			});
		}
		if (isEdit && location === 'plant') {
			if (this.state.plantGeoFene != []) {
				this.state.plantPolygon.map((value, index) => {
					value.setMap(null);
				});
			}
			this.setState({
				plantGeoFene: [],
				plantPolygon: [],
				haveDrawPointOnMap: false,
			});
		}
	};

	handleFindArea = (e) => {
		if (this.state.isSiteEdit) {
			this.clearAreaMarker(this.state.isSiteEdit, 'site');

			this.setState({
				isMenuMapToolsCLick: 'findArea',
			});

			new this.state.maps.Polyline();

			let self = this;
			let polygonCoords = [];
			let polygonLayer = null;

			this.setState({
				siteGeoFene: [],
			});
			this.state.maps.event.addListener(this.state.map, 'click', function(event) {
				self.setState({ haveDrawPointOnMap: true });
				polygonCoords.push({
					lat: event.latLng.lat(),
					lng: event.latLng.lng(),
				});

				self.state.siteGeoFene.push(event.latLng.lat(), event.latLng.lng());

				if (polygonLayer != null) polygonLayer.setMap(null);
				polygonLayer = new self.state.maps.Polygon({
					path: polygonCoords,
					strokeColor: '#8415FF',
					strokeOpacity: 1,
					strokeWeight: 2.3,
					fillColor: '#8415FF',
					fillOpacity: 0.35,
					editable: true,
					geodesic: true,
				});

				self.state.maps.event.addListener(polygonLayer.getPath(), 'remove_at', function() {
					self.state.siteGeoFene = [];

					var curLatLng;
					curLatLng = polygonLayer.getPath().getArray();
					for (let i = 0; i < curLatLng.length; i++) {
						self.state.siteGeoFene.push(curLatLng[i].lat(), curLatLng[i].lng());
					}
				});

				self.state.maps.event.addListener(polygonLayer.getPath(), 'set_at', function() {
					self.state.siteGeoFene = [];

					var curLatLng;
					curLatLng = polygonLayer.getPath().getArray();
					for (let i = 0; i < curLatLng.length; i++) {
						self.state.siteGeoFene.push(curLatLng[i].lat(), curLatLng[i].lng());
					}
				});
				polygonLayer.setMap(self.state.map);
				self.setState({
					sitePolygon: [...self.state.sitePolygon, polygonLayer],
				});
			});
		}
		if (this.state.isPlantEdit) {
			this.clearAreaMarker(this.state.isPlantEdit, 'plant');
			this.setState({
				isMenuMapToolsCLick: 'findArea',
			});

			new this.state.maps.Polyline();
			let self = this;
			let polygonCoords = [];
			let polygonLayer = null;
			this.setState({ plantGeoFene: [] });

			this.state.maps.event.addListener(this.state.map, 'click', function(event) {
				self.setState({ haveDrawPointOnMap: true });
				polygonCoords.push({
					lat: event.latLng.lat(),
					lng: event.latLng.lng(),
				});
				self.state.plantGeoFene.push(event.latLng.lat(), event.latLng.lng());

				if (polygonLayer != null) polygonLayer.setMap(null);
				polygonLayer = new self.state.maps.Polygon({
					path: polygonCoords,
					strokeColor: '#8415FF',
					strokeOpacity: 1,
					strokeWeight: 2.3,
					fillColor: '#8415FF',
					fillOpacity: 0.35,
					editable: true,
					geodesic: true,
				});

				self.state.maps.event.addListener(polygonLayer.getPath(), 'remove_at', function() {
					self.state.plantGeoFene = [];

					var curLatLng;
					curLatLng = polygonLayer.getPath().getArray();
					for (let i = 0; i < curLatLng.length; i++) {
						self.state.plantGeoFene.push(curLatLng[i].lat(), curLatLng[i].lng());
					}
				});

				self.state.maps.event.addListener(polygonLayer.getPath(), 'set_at', function() {
					self.state.plantGeoFene = [];

					var curLatLng;
					curLatLng = polygonLayer.getPath().getArray();
					for (let i = 0; i < curLatLng.length; i++) {
						self.state.plantGeoFene.push(curLatLng[i].lat(), curLatLng[i].lng());
					}
				});

				polygonLayer.setMap(self.state.map);
				self.setState({
					plantPolygon: [...self.state.plantPolygon, polygonLayer],
				});
			});
		}
	};

	handleApiLoaded = (map, maps) => {
		if (typeof maps == 'undefined' || maps == null) window.location.reload();
		this.setState({
			map: map,
			maps: maps,
			mapAPI: { ...this.state.mapAPI, trafficLayer: new maps.TrafficLayer() },
		});
	};

	handdleSaveButtonClick = () => {
		let self = this;
		let sdrId = self.props.match.params.id;
		console.log('plantGeoFene : ', self.state.plantGeoFene);
		console.log('siteGeoFene : ', self.state.siteGeoFene);
		// //fetch(`${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/updateGeofence`, {
		// fetch(`http://booking-api-88:88/api/updateGeofence`, {
		//   method: "POST",
		//   mode: "cors",
		//   headers: {
		//     // Accept: "application/json",
		//     "Content-Type": "application/json",
		//     // Authorization: `Bearer ${self.props.auth.accessToken}`
		//   },
		//   body: JSON.stringify({
		//     feed_id: sdrId,
		//     company_id: self.props.profile.company_id,
		//     plant_id: self.state.plantId,
		//     plant_geofence: self.state.plantGeoFene,
		//     site_id: self.state.siteId,
		//     site_lat: self.state.siteLat,
		//     site_lng: self.state.siteLng,
		//     site_geofence: self.state.siteGeoFene,
		//     site_modify_count: 1,
		//     flow: self.state.flow,
		//     changed: "T",
		//   }),
		// })
		//   .then((res) => {
		//     console.log(res);
		//   })
		//   .catch(function() {});
	};

	componentDidMount() {
		this.loadData();
	}

	render() {
		return (
			<AuthorizeComponent matching_name="concrete_dashboard">
				<GeneralStyledContent>
					<Row>
						<Col span={24}>
							<div
								style={{
									backgroundColor: '#F5F5F5',
									padding: 24,
								}}
							>
								<PageHeader
									ghost={false}
									onBack={() => window.history.back()}
									title="เทปูนนอกไซต์งาน"
									//   subTitle="This is a subtitle"
								>
									<Descriptions size="small" column={3}>
										<Descriptions.Item label="เลขตั๋ว">{this.state.ticketNo}</Descriptions.Item>
										<Descriptions.Item label="รหัสรถ">{this.state.vehicleCode}</Descriptions.Item>
										<Descriptions.Item label="ไซต์งาน">{this.state.siteName}</Descriptions.Item>
										<Descriptions.Item label="เริ่มโหลดปูน">
											{helper_convertDateformat(
												this.state.cementLoadStartDateTime,
												'YYYY-MM-DD HH:mm:ss',
												'DD/MM/YYYY HH:mm'
											)}
										</Descriptions.Item>
										<Descriptions.Item label="เวลาออกจากแพลนต์">
											{helper_convertDateformat(
												this.state.plantDepartureDateTime,
												'YYYY-MM-DD HH:mm:ss',
												'DD/MM/YYYY HH:mm'
											)}
										</Descriptions.Item>
										<Descriptions.Item label="เวลาถึงไซต์งาน">
											{helper_convertDateformat(
												this.state.siteArrivalDateTime,
												'YYYY-MM-DD HH:mm:ss',
												'DD/MM/YYYY HH:mm'
											)}
										</Descriptions.Item>
										<Descriptions.Item label="เริ่มเทปูน">
											{helper_convertDateformat(
												this.state.cementUnloadStartDateTime,
												'YYYY-MM-DD HH:mm:ss',
												'DD/MM/YYYY HH:mm'
											)}
										</Descriptions.Item>
										<Descriptions.Item label="ปริมาณ">
											{this.state.unloadQuntityPerAmount}
										</Descriptions.Item>
										<Descriptions.Item label="เวลาออกจากไซต์งาน">
											{helper_convertDateformat(
												this.state.siteDepartureDateTime,
												'YYYY-MM-DD HH:mm:ss',
												'DD/MM/YYYY HH:mm'
											)}
										</Descriptions.Item>
										<Descriptions.Item label="Address">{this.state.address}</Descriptions.Item>
										<Descriptions.Item label="Description">
											{this.state.description}
										</Descriptions.Item>
									</Descriptions>
								</PageHeader>
							</div>
						</Col>
					</Row>
					<Row>
						<Col span={13}>
							<div
								style={{
									position: 'absolute',
									marginTop: '4px',
									top: '0px',
									right: '0px',
									zIndex: '12',
								}}
							>
								<ButtonGroup
									style={{
										marginRight: '4px',
									}}
								>
									{/* {this.state.haveDrawPointOnMap ? (
										<Popconfirm
											placement="bottomRight"
											title={
												<LangContext.Consumer>
													{(i18n) => i18n.p.preventRePinLocationConfirm}
												</LangContext.Consumer>
											}
											onConfirm={this.handleFindArea}
											okText={
												<LangContext.Consumer>{(i18n) => i18n.o.okay}</LangContext.Consumer>
											}
											cancelText={
												<LangContext.Consumer>{(i18n) => i18n.c.cancel}</LangContext.Consumer>
											}
										>
											<Tooltip
												placement="top"
												title={
													<LangContext.Consumer>{(i18n) => i18n.d.draw}</LangContext.Consumer>
												}
											>
												<Button
													style={{
														backgroundColor: this.state.haveDrawPointOnMap
															? 'rgb(22, 146, 255)'
															: '',
														color: this.state.haveDrawPointOnMap
															? 'rgb(255, 255, 255)'
															: '',
													}}
												>
													<Icon type="yuque" />
												</Button>
											</Tooltip>
										</Popconfirm>
									) : ( */}
									<Tooltip
										placement="top"
										title={<LangContext.Consumer>{(i18n) => i18n.d.draw}</LangContext.Consumer>}
									>
										<Button
											onClick={this.handleFindArea}
											style={{
												backgroundColor: this.state.haveDrawPointOnMap
													? 'rgb(22, 146, 255)'
													: '',
												color: this.state.haveDrawPointOnMap ? 'rgb(255, 255, 255)' : '',
											}}
										>
											<Icon type="yuque" />
										</Button>
									</Tooltip>
									{/* )} */}
									<Tooltip
										placement="top"
										title={<LangContext.Consumer>{(i18n) => i18n.c.clearUp}</LangContext.Consumer>}
									>
										<Button style={{ marginRight: '10px' }} onClick={() => this.handleClearUp()}>
											<Icon type="close" />
										</Button>
									</Tooltip>
								</ButtonGroup>
							</div>
							<GoogleMapReact
								bootstrapURLKeys={{
									key: this.props.auth.profile.google_map_key,
									// key: '',
									libraries: process.env.REACT_APP_GOOGLE_MAP_USING_LIBRARIES.split(','),
									region: 'thailand',
									language: 'th',
								}}
								defaultCenter={this.state.mapOptions.center}
								defaultZoom={this.state.mapOptions.zoom}
								style={{
									width: '95%',
									minHeight: `${window.innerHeight - 150}px`,
								}}
								yesIWantToUseGoogleMapApiInternals
								onGoogleApiLoaded={({ map, maps }) => this.handleApiLoaded(map, maps)}
								options={{
									mapTypeControl: false,
									fullscreenControl: false,
									zoomControl: true,
									maxZoom: 19,
								}}
							>
								{this.state.plantLat != '' && (
									<IconMarker
										title={`แพลนต์`}
										lat={parseFloat(this.state.plantLat)}
										lng={parseFloat(this.state.plantLng)}
										image={defaultPlantImg}
										isshowetitle={true}
										alwaysShowTooltip={true}
									/>
								)}
								{this.state.siteLat != '' && (
									<IconMarker
										title={`ไซต์`}
										lat={parseFloat(this.state.siteLat)}
										lng={parseFloat(this.state.siteLng)}
										image={defaultSiteImg}
										isshowetitle={true}
										alwaysShowTooltip={true}
									/>
								)}
								{this.state.tableDetailData.map((ele) => (
									<IconMarker
										title={`${ele.unload_start_at}`}
										lat={parseFloat(ele.lat)}
										lng={parseFloat(ele.lng)}
										image={
											'http://icons.iconarchive.com/icons/paomedia/small-n-flat/32/map-marker-icon.png'
										}
										isshowetitle={true}
									/>
								))}
							</GoogleMapReact>
						</Col>
						<Col span={1} />
						<Col span={10}>
							<h3 style={{ marginTop: '10px' }}>
								<LangContext.Consumer>{(i18n) => 'รายการเทปูนนอกไซต์งาน'}</LangContext.Consumer>
							</h3>
							<Row>
								<Col span={12}>
									<Button
										block
										type={this.state.isSiteEdit ? 'primary' : 'default'}
										onClick={() => {
											this.setState(
												{
													isSiteEdit: true,
													isPlantEdit: false,
												},
												() => {
													// this.clearAreaMarker(true, 'site');
													this.clearAreaMarker(true, 'plant');
												}
											);
										}}
									>
										แก้ไขพิกัดไซต์
									</Button>
								</Col>
								<Col span={12}>
									<Button
										block
										type={this.state.isPlantEdit ? 'primary' : 'default'}
										onClick={() => {
											this.setState(
												{
													isPlantEdit: true,
													isSiteEdit: false,
												},
												() => {
													// this.clearAreaMarker(true, 'plant');
													this.clearAreaMarker(true, 'site');
												}
											);
										}}
									>
										แก้ไขพิกัดแพลนต์
									</Button>
								</Col>
							</Row>

							<Table
								scroll={{ y: '360px' }}
								rowKey={(record, i) => record.vehicle + '_' + i}
								className="tracking-table"
								columns={col}
								dataSource={this.state.tableDetailData}
								size="small"
								pagination={false}
							/>
						</Col>
					</Row>
					<Row>
						<Col xs={24} sm={24} md={24} lg={24} xl={24} style={{ margin: '20px 0px 0px 0px' }}>
							<Button
								type="default"
								style={{ margin: '0px 8px 0px 0px' }}
								onClick={() => window.history.back()}
							>
								<LangContext.Consumer>{(i18n) => i18n.b.back}</LangContext.Consumer>
							</Button>

							<Button htmlType="submit" type="primary" onClick={this.handdleSaveButtonClick}>
								<LangContext.Consumer>{(i18n) => i18n.s.save}</LangContext.Consumer>
							</Button>
						</Col>
					</Row>
				</GeneralStyledContent>
			</AuthorizeComponent>
		);
	}
}

export default withRouter(
	connect(
		({ monitoringState, auth, auth: { profile } }) => ({
			monitoringState,
			auth,
			profile,
		}),
		{
			loadDashcamera: loadDashcamera.request,
			removeLists,
			loadEmergencyCase: loadEmergencyCase.request,
		}
	)(ActivityOutSideArea)
);
